import {
  ADD_TO_CART,
  ADD_TO_FAVORITE,
  CLEAR_CART,
  CLEAR_FAVORITE,
  COUNT_CART_TOTALS,
  REMOVE_CART_ITEM,
  REMOVE_FAVORITE_ITEM,
  TOGGLE_CART_ITEM_AMOUNT,
} from "../actions";

const cart_reducer = (state, action) => {
  if (action.type === ADD_TO_CART) {
    const { _id, amount, product } = action.payload;
    const tempItem = state.cart.find((i) => i.id === _id);
    if (tempItem) {
      const tempCart = state.cart.map((cartItem) => {
        if (cartItem.id === _id) {
          let newAmount = cartItem.amount + amount;
          if (newAmount > cartItem.quantity) {
            newAmount = cartItem.quantity;
          }
          return { ...cartItem, amount: newAmount };
        } else {
          return cartItem;
        }
      });

      return { ...state, cart: tempCart };
    } else {
      const newItem = {
        id: _id,
        name: product.name,
        amount,
        productPictures: product.productPictures,
        price: product.price,
        quantity: product.quantity,
      };
      return { ...state, cart: [...state.cart, newItem] };
    }
  }

  if (action.type === REMOVE_CART_ITEM) {
    const tempCart = state.cart.filter((item) => item.id !== action.payload);
    return { ...state, cart: tempCart };
  }

  if (action.type === CLEAR_CART) {
    return { ...state, cart: [] };
  }

  if (action.type === TOGGLE_CART_ITEM_AMOUNT) {
    const { id, value } = action.payload;
    const tempCart = state.cart.map((item) => {
      if (item.id === id) {
        if (value === "inc") {
          let newAmount = item.amount + 1;
          if (newAmount > item.quantity) {
            newAmount = item.quantity;
          }
          return { ...item, amount: newAmount };
        }
        if (value === "dec") {
          let newAmount = item.amount - 1;
          if (newAmount < 1) {
            newAmount = 1;
          }
          return { ...item, amount: newAmount };
        }
      }
      return item;
    });

    return { ...state, cart: tempCart };
  }

  if (action.type === COUNT_CART_TOTALS) {
    const { total_items, total_amount } = state.cart.reduce(
      (total, cartItem) => {
        const { price, amount } = cartItem;
        total.total_items += amount;
        total.total_amount += price * amount;

        return total;
      },
      {
        total_items: 0,
        total_amount: 0,
      }
    );
    return { ...state, total_items, total_amount };
  }

  if (action.type === ADD_TO_FAVORITE) {
    const { _id, product } = action.payload;
    const tempItem = state.favorite.find((i) => i.id === _id);
    if (tempItem) {
      const tempCart = state.favorite.filter(
        (item) => item.id !== action.payload
      );
      return { ...state, favorite: tempCart };
    } else {
      const newItem = {
        id: _id,
        name: product.name,
        productPictures: product.productPictures,
        price: product.price,
        quantity: product.quantity,
      };
      return { ...state, favorite: [...state.favorite, newItem] };
    }
  }

  if (action.type === REMOVE_FAVORITE_ITEM) {
    const tempCart = state.favorite.filter(
      (item) => item.id !== action.payload
    );
    return { ...state, favorite: tempCart };
  }

  // if (action.type === COUNT_FAVORITE_TOTALS) {
  //   const { total_items, total_amount } = state.cart.reduce(
  //     (total, cartItem) => {
  //       const { price, amount } = cartItem;
  //       total.total_items += amount;
  //       total.total_amount += price * amount;

  //       return total;
  //     },
  //     {
  //       total_items: 0,
  //       total_amount: 0,
  //     }
  //   );
  //   return { ...state, total_items, total_amount };
  // }

  if (action.type === CLEAR_FAVORITE) {
    return { ...state, cart: [] };
  }

  throw new Error(`No Matching "${action.type}" - action type`);
};

export default cart_reducer;
